import {createRouter, createWebHashHistory} from "vue-router";
import Home from "@/views/home.vue";
import myMain from "@/views/my/main.vue";
import {useUserStore} from '@/stores/user'


// Vue.use(VueRouter);

// let originPush = VueRouter.prototype.push; //备份原push方法

// 重写 Vue-router 原型对象上的 push 函数
// 防止多次点击跳转同一个路由时报错
// VueRouter.prototype.push = function (location, resolve, reject) {
//     if (resolve && reject) {
//         //如果传了回调函数，直接使用
//         originPush.call(this, location, resolve, reject);
//     } else {
//         //如果没有传回调函数，手动添加
//         originPush.call(
//             this,
//             location,
//             () => {
//             },
//             () => {
//             }
//         );
//     }
// };

const routes = [
    {
        path: "/login",
        component: () => import("@/views/login/login.vue"),
        meta: {
            title: "login",
        },
    },
    {
        path: "/forget",
        component: () => import("@/views/login/forget.vue"),
        meta: {
            title: "forget",
        },
    },
    {
        path: "/question",
        component: () => import("@/views/login/question.vue"),
        meta: {
            title: "question",
        },
    },
    {
        path: "/message",
        component: () => import("@/views/message/message.vue"),
        meta: {
            title: "message",
        },
    },
    // {
    //     path: "/download",
    //     component: () => import("@/views/login/download.vue"),
    //     meta: {
    //         title: "download",
    //     },
    // },
    {
        path: "/",
        component: Home,
        redirect: "/index",
        children: [
            {
                path: "/index",
                component: () => import("@/views/home/index.vue"),
                meta: {
                    title: "index",
                },
            },
            {
                path: "/select-game",
                component: () => import("@/views/home/select-game.vue"),
                meta: {
                    title: "select-game",
                },
            },
            {
                path: "/s-game-detail",
                component: () => import("@/views/home/s-game-detail.vue"),
                meta: {
                    title: "s-game-detail",
                },
            },
            {
                path: "/search",
                component: () => import("@/views/home/search.vue"),
                meta: {
                    title: "search",
                },
            },
            {
                path: "/account-detail",
                component: () => import("@/views/home/account-detail.vue"),
                meta: {
                    title: "account-detail",
                },
            },
            {
                path: "/s-game-auction-list",
                component: () => import("@/views/home/s-game-auction-list.vue"),
                meta: {
                    title: "s-game-auction-list",
                },
            },
            {
                path: "/accout-auction-detail",
                component: () => import("@/views/home/accout-auction-detail.vue"),
                meta: {
                    title: "accout-auction-detail",
                },
            },
            {
                path: "/s-game-auction",
                component: () => import("@/views/home/s-game-auction.vue"),
                meta: {
                    title: "s-game-auction",
                },
            },
            {
                path: "/s-game-sale",
                component: () => import("@/views/home/s-game-sale.vue"),
                meta: {
                    title: "s-game-sale",
                },
            },
            {
                path: "/xt-tongzhi",
                component: () => import("@/views/home/xt-tongzhi.vue"),
                meta: {
                    title: "xt-tongzhi",
                },
            },
            {
                path: "/about",
                component: () => import("@/views/home/about.vue"),
                meta: {
                    title: "about",
                },
            },
            {
                path: "/safe-center-hhcx",
                component: () => import("@/views/home/safe-center-hhcx.vue"),
                meta: {
                    title: "safe-center-hhcx",
                },
            },
            {
                path: "/service-guide",
                component: () => import("@/views/home/service-guide.vue"),
                meta: {
                    title: "service-guide",
                },
            },
            {
                path: "/service-guide-detail",
                component: () => import("@/views/home/service-guide-detail.vue"),
                meta: {
                    title: "service-guide-detail",
                },
            },
            {
                path: "/personal-home",
                component: () => import("@/views/home/personal-home.vue"),
                meta: {
                    title: "personal-home",
                },
            },
            {
                path: "/order-confirm",
                component: () => import("@/views/home/order-confirm.vue"),
                meta: {
                    title: "order-confirm",
                },
            }
        ]
    },
    {
        path: "/buy",
        component: myMain,
        redirect: "/buy",
        children: [
            {
                path: "/buy",
                component: () => import("@/views/my/buy.vue"),
                meta: {
                    title: "buy",
                },
            },
            {
                path: "/sale",
                component: () => import("@/views/my/sale.vue"),
                meta: {
                    title: "sale",
                },
            },
            {
                path: "/issue",
                component: () => import("@/views/my/issue.vue"),
                meta: {
                    title: "issue",
                },
            },
            {
                path: "/in-auction",
                component: () => import("@/views/my/in-auction.vue"),
                meta: {
                    title: "in-auction",
                },
            },
            {
                path: "/after-sale",
                component: () => import("@/views/my/after-sale.vue"),
                meta: {
                    title: "after-sale",
                },
            },
            {
                path: "/evaluate",
                component: () => import("@/views/my/evaluate.vue"),
                meta: {
                    title: "evaluate",
                },
            },
            {
                path: "/real-name",
                component: () => import("@/views/my/real-name.vue"),
                meta: {
                    title: "real-name",
                },
            },
            {
                path: "/collect",
                component: () => import("@/views/my/collect.vue"),
                meta: {
                    title: "collect",
                },
            },
            {
                path: "/history",
                component: () => import("@/views/my/history.vue"),
                meta: {
                    title: "history",
                },
            },
            {
                path: "/wallet",
                component: () => import("@/views/my/wallet.vue"),
                meta: {
                    title: "wallet",
                },
            },
            {
                path: "/pact",
                component: () => import("@/views/my/pact.vue"),
                meta: {
                    title: "pact",
                },
            },
            {
                path: "/personal",
                component: () => import("@/views/my/personal.vue"),
                meta: {
                    title: "personal",
                },
            },
            {
                path: "/account-safe",
                component: () => import("@/views/my/account-safe.vue"),
                meta: {
                    title: "account-safe",
                },
            },
            {
                path: "/sk-zhanghu",
                component: () => import("@/views/my/sk-zhanghu.vue"),
                meta: {
                    title: "sk-zhanghu",
                },
            },
        ]
    },
    {
        path: "/404",
        component: () => import("@/views/rests/404.vue"),
        meta: {
            title: "404",
        },
    },
    {
        path: "/networkError",
        component: () => import("@/views/rests/networkError.vue"),
        meta: {
            title: "networkError",
        },
    },
    {
        path: "/:pathMatch(.*)",
        redirect: "/404",
        hidden: true,
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

//全局路由守卫
router.beforeEach((to, from, next) => {
    const store = useUserStore()
    // const token = localStorage.getItem('userToken') || ''
    const token = store.userToken || ''
    let arr = ['/index', '/login', '/forget', '/question', '/about', '/safe-center-hhcx', '/service-guide', '/service-guide-detail', '/search', '/account-detail', '/accout-auction-detail', '/select-game', '/s-game-detail', '/s-game-auction-list']
    if (!arr.includes(to.path) && !token) {
        return next({path: '/login'});
    } else {
        if (token) {
            store.getUserInfo()
        }
        return next()
    }
})
export default router;
